export default __webpack_public_path__ + "static/media/rofl.728278eb.gif";